import React, { useEffect, useState } from "react";
import {
  GET_LIST,
  Toolbar,
  SaveButton,
  Link,
  Button,
  Title
} from "react-admin";
import { Card} from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import moment_tz from "moment-timezone";
import {
  map,
  curry,
  range,
  isNil,
} from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import FormControl from "@material-ui/core/FormControl";
import CustomDatePicker from "./customDatePicker";
import Search from "@material-ui/icons/Search";
import GetApp from '@material-ui/icons/GetApp';
import ReactExport from "react-data-export";
import ReactDOM from 'react-dom';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const styles = {
  container: {
    marginLeft: "0em",
    textAlign: "center",
  },
  rightAlignedCell: { textAlign: "right" },
  leftAlignedCell: { textAlign: "left" },
  centerAlignedCell: { textAlign: "center" },
  title: { backgroundColor: "#ff9800" },
  blackBold: { fontWeight: "bold", color: "black" },
  boldCell: { fontWeight: "bold" },
  widthTable: {
    marginLeft: "30px",
    width: "70%",
  },
  flex: { display: "flex", flexDirection:'column' },
  emailsCard: {padding: '10px 20px', backgroundColor: 'rgb(254 151 0 / 12%)', borderRadius: '4px',
              boxShadow: 'rgb(255 152 0 / 2%) 0px 30px 60px -12px inset, rgb(253 229 193) 0px 18px 36px -18px inset', 
              display: "flex", flexDirection: "row", margin: "20px", width: '50%', flexWrap: 'wrap'}
};

const StartForm = styled.div({
  margin: "30px",
  display: "flex",
  flexDirection: "column",
  width: "30%",
  justifyContent: "space-between"
});

let dataSetAll = [];
let dataSet1 = [];

class reportToursCharges extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      numberOfMonths: 2,
      yearsStart: 2016,
      yearsEnd: moment().startOf("year").format("YYYYMMDD"),
      optDateBegin: null,
      optDateEnd: null,
      loading: false,
      showTables: false,
      setLoading: false,
      exportData: [],
      setExportData: [],
      DataSet: [],
      month: moment().startOf("month").format("YYYYMMDD"),
    };
  }

  async componentDidMount() {
    moment_tz.tz.setDefault("Europe/Madrid");
    const startDate = moment().format("YYYYMMDD");
    const endDate = moment().format("YYYYMMDD");
    await this.updateState(startDate, endDate, null, null, null);

    const url = window.location.href;
    const parts = url.split("/");
    const location = parts[parts.length - 1];
    if (location === 'reportToursCharges') {
      const storedState = sessionStorage.getItem('reportToursChargesState');
      if (storedState) {
        const state = JSON.parse(storedState);
        this.setState({
          optDateBegin: state.optDateBegin,
          optDateEnd: state.optDateEnd,
        });
        this.handleChange();
      }
    }
  }

  updateState = async (startDate, endDate, optDateBegin, optDateEnd) => {
    this.setState({
      isLoading: false,
      startDate,
      endDate,
      month: moment(startDate).format("YYYYMMDD"),
      optDateBegin,
      optDateEnd,
    });
  };

  sortedDayList = (start, end) => {
    const add = (day, offset) => day.clone().add(offset, "days");
    return map(curry(add)(start), range(0, end.diff(start, "days") + 1));
  };

  handleChangeOptE = (eventDate) => {
    this.setState({ optDateEnd: eventDate });
  };

  handleChangeOptB = (eventDate) => {
    this.setState({ optDateBegin: eventDate });
  };

  handleDateTimeChange = (event, fieldName) => {
    if (!isNil(event)) {
      this.setState({ [fieldName]: event });
    }
  };

  handleChange = () => {
    dataSetAll = [];
    if (
      this.state.optDateBegin !== null &&
      this.state.optDateEnd !== null &&
      this.state.optDateBegin !== "" &&
      this.state.optDateEnd !== ""
    ) {
      this.setState({ exportData: [], loading: true, showTables: true });
      sessionStorage.setItem('reportToursChargesState', JSON.stringify({
        optDateBegin: this.state.optDateBegin,
        optDateEnd: this.state.optDateEnd,
      }));
      this.getReports();
    }
  };

  async getReports() {
    const eventDateStart = moment(this.state.optDateBegin).format("YYYY-MM-DD");
    const eventDateEnd = moment(this.state.optDateEnd).format("YYYY-MM-DD");  
    const dataProvider = await dataProviderFactory("rest");
    const reportcharges = dataProvider(GET_LIST, "reports/reportToursCharges", {
      filter: {
        dateStart: eventDateStart,
        dateEnd: eventDateEnd,
      },
      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: { field: this.props.created_at, order: "DESC" },
    });

    reportcharges
      .then(async (result) => {
        this.state.loading = false;
        dataSetAll = result.data;
        this.setState({ loading: false });
        return result.data;
      })
      .catch((error) => {
        this.state.loading = false;
      });
  }

  async getDetails(tourId) {
    const dataProvider = await dataProviderFactory("rest");
    const chargesReport = dataProvider(
      GET_LIST,
      "reports/reportToursCharges/" + tourId,
      {
        filter: {
          tourId: tourId,
        },

        pagination: {
          page: 1,
          perPage: 99999,
        },
        sort: { field: this.props.created_at, order: "DESC" },
      }
    )

    chargesReport
      .then((result) => {
        this.state.loading = false;
        dataSet1 = result.data;
        const dataSet = [
          {
            columns: [
              {
                title: "Date",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              }, 
              {
                title: "Client",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              },
              {
                title: "Value",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              }, 
              {
                title: "Refund",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              }, 
              {
                title: "Invoice url",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 200 },
              }, 
            ],
            data: result.data.map((data) => [
              {
                value:
                  data.date != null
                    ? moment(data.date).format("DD/MM/YYYY")
                    : "",
                style: { font: { sz: "12" } },
              },
              {
                value: data.client != null ? data.client : "",
                style: { font: { sz: "12" } },
              },
              {
                value: data.value != null ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.value)
                : "",
                style: { font: { sz: "12" }, textAlign: { horizontal: 'right' } },
              },
              {
                value: data.refunded != null ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.refunded) 
                : "",
                alignment: { horizontal: 'bottom' },   
                style: { font: { sz: "12" } },   
              },
              {
                value: data.urlInvoice != null ? data.urlInvoice : "",
                style: { font: { sz: "12" } },
              },
            ]),
          },
        ];

        this.setState({
          isLoading: false,
          loading: false,
          exportData: result.data,
          DataSet: dataSet,
        });

        try{
          const container = document.createElement('div');
          container.innerHTML = '';
          document.body.appendChild(container);
          ReactDOM.render(
            <ExcelFile
              filename={"Tour " + tourId + " Charges"} 
              element={
                <button id={ tourId } style={{ display: 'none' }}></button>
              }
            >
              <ExcelSheet dataSet={this.state.DataSet} name="Charges" />
            </ExcelFile>,
            container
          );
          // Busca el botón de exportar a Excel y simula un clic
          const exportButton = document.getElementById(tourId);
          exportButton.click();

        } catch (error) {
          console.error(error);
        }          
      })
      .catch((error) => {
        this.state.loading = false;
      });
  }

  render() {
    const {
      isLoading,
      optDateBegin,
      optDateEnd,
    } = this.state;

    const { classes, ...props } = this.props;

    if (isLoading) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    const PostCreateToolbar = (props) => (
      <Toolbar {...props} style={{ backgroundColor: "transparent" }}>
        <SaveButton
          label="Generate"
          type="submit"
          onClick={this.handleChange}
        />
      </Toolbar>
    );

    return (
      <React.Fragment>
        <Title title="Tour Charges Report" />
        <Card>
          <StartForm>
            <h3>Tour Charges Report</h3>
            <div style={{display:'flex', flexDirection:'row', margin:'20px'}}>
              <div >
                <FormControl style={{ marginBottom: '10px', marginRight: '10px'}}>
                  <CustomDatePicker 
                    onChange={e => this.handleChangeOptB(e)}
                    minDate={'2022-01-01'}
                    selectedDate={
                    optDateBegin && optDateBegin !== "null"
                        ? moment(optDateBegin).format("YYYY-MM-DD")
                        : null
                    }
                    label="Date Begin"
                  /> 
                </FormControl>
                
                <FormControl style={{ marginBottom: '10px', marginLeft: '10px'}}>
                  <CustomDatePicker
                    onChange={e => this.handleChangeOptE(e)}
                    minDate={'2022-01-01'}
                    selectedDate={
                    optDateEnd && optDateEnd !== "null"
                      ? moment(optDateEnd).format("YYYY-MM-DD")
                      : null
                    }
                    label="Date End"
                  />  
                </FormControl>
              </div>
            </div>
            <PostCreateToolbar />
          </StartForm>

          {this.state.showTables ? (
            <div style={styles.flex}>
              <Table style={styles.widthTable}>
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={3} style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>
                      <h3> Tour Charges</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow style={styles.title}>
                    <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>TOUR ID</TableCell>
                    <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>NAME</TableCell>
                    <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>TOTAL CHARGES</TableCell>
                    <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>TOTAL REFUNDS</TableCell>
                    <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>DETAILS</TableCell>
                    <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>DOWNLOAD</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.keys(dataSetAll).map((id) => (
                    <TableRow key={id}>
                      <TableCell style={styles.centerAlignedCell}>
                          {dataSetAll[id].id}
                      </TableCell>
                      <TableCell style={styles.leftAlignedCell}>
                          {dataSetAll[id].name} 
                      </TableCell>
                      <TableCell style={styles.rightAlignedCell}>
                          {new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(dataSetAll[id].total)}
                      </TableCell>
                      <TableCell style={styles.rightAlignedCell}>
                          {new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(dataSetAll[id].refunds)}
                      </TableCell>
                      <TableCell style={styles.centerAlignedCell}>
                        <React.Fragment>
                          <Button
                            component={Link}
                            //target="_blank"
                            to={{
                              pathname: `/reportToursCharges/${dataSetAll[id].id}`,
                            }}
                            label="Details"
                            style={{ padding: "10px" }}
                          >
                            <Search/>
                          </Button>
                        </React.Fragment>
                      </TableCell>
                      <TableCell>
                        <React.Fragment>
                          <Button
                            label="Download"
                            style={{ padding: "10px" }}
                            onClick={() => this.getDetails(dataSetAll[id].id)}
                          >
                            <GetApp/>
                          </Button>
                        </React.Fragment>
                        {/* <ExcelExport tourId={dataSetAll[id].id} /> */}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>          
            </div> 
          ) : null}
          <div style={{ marginBottom: "10px" }}></div>
        </Card>        
      </React.Fragment>

    );
  }
}

export default reportToursCharges;



// WEBPACK FOOTER //
// ./src/components/reportToursCharges.js